<script>
    import {slide} from 'svelte/transition';

    export let title = '';
    let klass;
    export {klass as class};
    


    let showContent = true;

    function toggleContent() {
        showContent = !showContent;
    }
</script>

<style>
    section {
        margin-top: 30px;
    }
</style>

<section class={klass}>
    <a class="btn btn-link px-1"
       on:click={toggleContent}>
        <i class="fas fa5-minus" class:fa5-minus={showContent} class:fa5-plus={!showContent}></i>
    </a>
    <slot name="header">
        <h4 class="text-secondary d-inline-block">{title}</h4>
    </slot>

    {#if showContent}
        <div transition:slide|local class='section-content'>
            <slot></slot>
        </div>
    {/if}
</section>
